
import React, { useState, useEffect } from 'react'
import * as FcIcons from 'react-icons/fc';
import { useForm } from 'react-hook-form';
import AxiosService from "../services/axios.service";
import AuthService from "../services/auth.service";
const API_PATH = "requests";

function List(match) {
  const { path } = match;
  const [mod, setMod] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [reports, setReports] = useState(null);
  const [results, setResults] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {

    const user = AuthService.getCurrentUser();
    if (user) {
      setMod(user.roles.includes("ROLE_MODERATOR"));
      setAdmin(user.roles.includes("ROLE_ADMIN"));
    }
    AxiosService.getAll(API_PATH).then(x => {
      for (var j in x.data) {
        var agency_names_to_string = "";
        var agencies = x.data[j].agency;
        for (var i in agencies) {
          console.log(agencies[i].name);
          agency_names_to_string += agencies[i].name + " ";
        }
        console.log(agency_names_to_string);
        x.data[j].agencies = agency_names_to_string
      }
      setReports(x.data);
      setResults(x.data.length);
    }
    );
  }, []);

  const { register, watch, formState: { errors }, handleSubmit } = useForm();

  function search() {
    var keyword = watch("query").toLowerCase();
    console.log("keyword: " + keyword);
    AxiosService.getAll(API_PATH).then(x => {
      console.log(JSON.stringify(x.data));
      var queries = x.data.filter(item => item.agency.toLowerCase().includes(keyword) || item.agency_tracking_numbers.toLowerCase().includes(keyword) || item.current_status.toLowerCase().includes(keyword) || item.subject.toLowerCase().includes(keyword) || item.short_description.toLowerCase().includes(keyword))
      setReports(queries)
      setResults(queries.length)
    }
    );
  }

  return (
    <div>
      <h1 style={{ textAlign: 'center' }}>Reports</h1>
      <form onSubmit={handleSubmit(search)} onReset={useEffect}>
        <div className="form-row">
          <div className="form-group col-5">
            <input name="query" type="text" ref={register} {...register("query", {})} className={`form-control ${errors.query ? 'is-invalid' : ''}`} />
            <div className="invalid-feedback">{errors.query?.message}</div>
          </div>
          <div className="form-group col-5">
            {/*<button onClick={search} style={{ marginRight: 8 }} class="btn btn-light" id="search">Search <FcIcons.FcSearch size={24} /></button>*/}
            <button class="btn btn-light" type="submit">Search <FcIcons.FcSearch size={24} /></button>
          </div>
        </div>
      </form>
      <h5>Results: {results}</h5>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th style={{ width: '20%' }}>Agency</th>
            <th style={{ width: '20%' }}>Agency Tracking Numbers</th>
            <th style={{ width: '20%' }}>Short Description</th>
            <th style={{ width: '20%' }}>Acknowledged</th>
            <th style={{ width: '20%' }}>Records received?</th>
          </tr>
        </thead>
        <tbody>
          {reports && reports.map(report =>
            <tr key={report.id}>
              <td>{report.agency}</td>
              <td>{report.agency_tracking_numbers}</td>
              <td>{report.short_description}</td>
              <td>{report.acknowledgement_date}</td>
              <td>{report.records_received}</td>
            </tr>
          )}
          {!reports &&
            <tr>
              <td colSpan="4" className="text-center">
                <div className="spinner-border spinner-border-lg align-center"></div>
              </td>
            </tr>
          }
          {reports && !reports.length &&
            <tr>
              <td colSpan="4" className="text-center">
                <div className="p-2">No Reports To Display</div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  );
}

export { List };
